(() => {
  const initializeCartDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    const trigger = document.getElementById('cart-icon');

    if (!drawer || drawer.dataset.brandCartReady === 'true') return;
    drawer.dataset.brandCartReady = 'true';

    // Enterprise's refresh error path expects this property but never creates it.
    // A getter keeps the reference current after Shopify replaces drawer markup.
    Object.defineProperty(drawer, 'errorMsg', {
      configurable: true,
      get() {
        return this.querySelector('#cart-errors') || { textContent: theme.strings.cartError };
      }
    });

    const syncDrawerState = (itemCount) => {
      const count = Number(itemCount) || 0;
      const countElement = drawer.querySelector('[data-cart-count]');
      const viewCartLink = drawer.querySelector('[data-cart-view-link]');

      if (countElement) countElement.textContent = `(${count})`;
      if (viewCartLink) viewCartLink.hidden = count === 0;
    };

    drawer.addEventListener('on:cart-drawer:before-open', () => {
      trigger?.setAttribute('aria-expanded', 'true');
    });

    drawer.addEventListener('on:cart-drawer:before-close', () => {
      trigger?.setAttribute('aria-expanded', 'false');
    });

    drawer.addEventListener('on:line-item:change', (event) => {
      const itemCount = event.detail?.cart?.item_count;
      if (typeof itemCount !== 'number') return;

      syncDrawerState(itemCount);

      if (itemCount === 0) {
        requestAnimationFrame(() => {
          const emptyState = drawer.querySelector('.js-cart-empty');
          const primaryAction = emptyState?.querySelector('.cart-empty__all');

          if (emptyState && primaryAction && typeof trapFocus === 'function') {
            trapFocus(drawer, primaryAction);
          } else {
            primaryAction?.focus();
          }
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCartDrawer, { once: true });
  } else {
    initializeCartDrawer();
  }
})();
